export default __webpack_public_path__ + "static/media/statue_of_liberty.5470e972.jpg";